export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/suv-icon.9629e9a6.svg","height":12,"width":24,"blurWidth":0,"blurHeight":0};